import { method } from 'lodash'
import { request } from './request'
// 获取任务列表
export interface GetEmailGatewayData {
  limit: number
  page: number
  task_id?: number
  keyword?: string
  start_time?: string
  end_time?: string
  score_level?: number
  result_status?: number
  biz_area?: string
}

// 获取任务列表
export interface TaskListProps {
  //  安全域
  areaName?: string[]
  createTimeEnd?: string
  createTimeStart?: string
  //  任务分组
  groupId?: string
  //  每页几条
  limit?: number
  //  第几页
  page?: number
  //  任务名称/客户端名称
  search?: string
  //  任务状态
  //  TaskResultStatusWaiting: 等待中
  //  TaskResultStatusProcessing: 进行中
  //  TaskResultStatusFinished: 已完成
  //  TaskResultStatusInterrupted: 已中断
  //  TaskResultStatusStopping: 停止中
  taskStatus?: string[]
  //  验证类型
  //  VerificationTypeOnline: 在线验证
  //  VerificationTypeOffline: 离线验证
  verificationType?: string
  [property: string]: any
}
export const getEmailGateway = (data: GetEmailGatewayData) =>
  request('/portal/verify/emailGateway/resultList', {
    params: {
      ...data,
    },
  })
//  删除列表
export interface DeleteList {
  result_id_list: number[]
}
export const deleteList = (data: DeleteList) =>
  request('/portal/verify/emailGateway/batchDeleteResult', {
    method: 'delete',
    data,
  })

// 获取安全域列表
export const getBizAreaList = () => request('/portal/verify/email_gateway/task_select/areas')

//停止任务
export const stopTask = data =>
  request('/portal/verify/emailGateway/stopTask', {
    method: 'post',
    data,
  })

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/verify/email_gateway/task_results/${data.resultId}/case`)

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/verify/email_gateway/task_results/${data.resultId}/case/count`, {
    params: {
      ...data,
    },
  })

// 获取任务详情
export const getTaskDetail = (id: string) => request(`/portal/verify/email_gateway/tasks/${id}`)

// 获取任务分组列表
export const getGroupList = data =>
  request(`/portal/verify/email_gateway/task_select/groups`, { params: data })

// 主任务删除
export const deleteTask = (taskIds: string[]) =>
  request(`/portal/verify/email_gateway/task`, { method: 'post', data: { taskIds } })

// 获取任务执行列表
export const getTaskExecList = (id: string, data: TaskListProps) =>
  request(`/portal/v1/emailGateway/tasks/${id}/results`, {
    params: {
      ...data,
    },
  })

// 主任务列表
export const getResultList = (data: TaskListProps) =>
  request('/portal/v1/emailGateway/tasks', {
    params: {
      ...data,
    },
  })

// 2.0.2
// 关联模板列表
export const getTaskDetailTemplateList = data =>
  request(`/portal/verify/email_gateway/tasks/${data.taskId}/templates`, { params: data })

// 关联模板用例列表
export const getTaskDetailCaseList = data =>
  request(`/portal/verify/email_gateway/task_detail/resources`, {
    method: 'post',
    data,
  })

// 关联模板用例的攻击类型筛选
export const getTaskDetailCaseAttackType = data =>
  request(`/portal/common/attackTypeList`, {
    method: 'post',
    data,
  })

// 获取安全设备列表
export const getSecurityDeviceList = () =>
  request('/portal/verify/email_gateway/task_select/devices')

// 获取目标主体
export const getSecurityTarget = () => request('/portal/verify/email_gateway/task_select/targets')

// 获取任务基础信息
export const getTaskBaseInfo = (id: string) => request(`/portal/verify/email_gateway/tasks/${id}`)
